/* Baby Basket — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const BB = window.BB || { routes: {}, strings: {} };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const openDrawer = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const f = $('[data-drawer-close]:not(.drawer__overlay)', drawer); f && f.focus(); }, 50);
  };
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.drawerOpen);
      if (d) { e.preventDefault(); openDrawer(d); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    const link = e.target.closest('[data-drawer-link]');
    if (link) { const d = link.closest('[data-drawer]'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Header shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotator (mobile) ---------- */
  const rot = $('[data-rotator]');
  if (rot) {
    const items = $$('.announcement__item', rot);
    let i = 0;
    if (items.length > 1) setInterval(() => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------- Reveal on scroll ---------- */
  const revealAll = (root = document) => {
    const els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    els.forEach((el) => io.observe(el));
  };
  revealAll();

  /* ---------- Home grid filters ---------- */
  const filters = $('[data-filters]');
  if (filters) {
    const cards = $$('[data-grid] .card');
    filters.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter]');
      if (!btn) return;
      $$('[data-filter]', filters).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      const f = btn.dataset.filter;
      cards.forEach((c) => {
        const show = f === 'all' || (c.dataset.cats || '').split(' ').includes(f);
        c.hidden = !show;
        if (show) { c.classList.remove('is-entering'); void c.offsetWidth; c.classList.add('is-entering', 'is-in'); }
      });
    });
  }

  /* ---------- Sort select ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Toast ---------- */
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
  };

  /* ---------- Cart ---------- */
  const SECTION = 'cart-drawer';
  const sectionsUrl = window.location.pathname;
  const renderDrawer = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    const current = $('[data-cart-drawer]');
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.querySelector('.drawer__panel').replaceWith(fresh.querySelector('.drawer__panel'));
      if (wasOpen) current.classList.add('is-open');
    }
    const countSrc = doc.querySelector('[data-cart-count-source]');
    if (countSrc) {
      const n = countSrc.textContent.trim();
      $$('[data-cart-count]').forEach((el) => { el.textContent = n === '0' ? '' : n; el.dataset.count = n; });
    }
  };
  const refreshDrawer = () => fetch(`${sectionsUrl}?sections=${SECTION}`)
    .then((r) => r.json()).then((d) => renderDrawer(d[SECTION]));

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    const fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', sectionsUrl);
    fetch(`${BB.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) { toast(data.description || data.message || BB.strings.error); return; }
        if (data.sections) renderDrawer(data.sections[SECTION]); else return refreshDrawer();
      })
      .then(() => {
        const drawer = $('[data-cart-drawer]');
        if (drawer && !drawer.classList.contains('is-open') && $('.cart-line', drawer)) openDrawer(drawer);
      })
      .catch(() => toast(BB.strings.error))
      .finally(() => { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = label; } });
  });

  const changeLine = (line, quantity) => {
    const onCartPage = !!$('[data-cart-page]');
    return fetch(`${BB.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: SECTION, sections_url: sectionsUrl })
    }).then((r) => r.json()).then((data) => {
      if (onCartPage) { window.location.reload(); return; }
      if (data.sections) renderDrawer(data.sections[SECTION]); else refreshDrawer();
    }).catch(() => toast(BB.strings.error));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (!b) return;
    const line = b.closest('[data-line]');
    if (!line) return;
    b.disabled = true;
    line.style.opacity = '.5';
    changeLine(Number(line.dataset.line), Math.max(0, Number(b.dataset.lineQty)));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (!input) return;
    const line = input.closest('[data-line]');
    changeLine(Number(line.dataset.line), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------- Quantity steppers ---------- */
  $$('[data-qty]').forEach((q) => {
    const input = $('input', q);
    $('[data-qty-minus]', q).addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    $('[data-qty-plus]', q).addEventListener('click', () => { input.value = Math.min(Number(input.max) || 99, (parseInt(input.value, 10) || 1) + 1); });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const thumbs = $$('[data-thumb]', g);
    const dots = $$('.gallery__dots span', g);
    const rtl = document.documentElement.dir === 'rtl';
    const setActive = (i) => {
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.dataset.thumb);
      const w = track.clientWidth;
      track.scrollTo({ left: rtl ? -i * w : i * w, behavior: 'smooth' });
      setActive(i);
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(Math.abs(track.scrollLeft) / track.clientWidth)));
    }, { passive: true });
  });

  /* ---------- Variant select (multi-variant products) ---------- */
  const variantsJson = $('[data-variants]');
  if (variantsJson) {
    const variants = JSON.parse(variantsJson.textContent);
    const selects = $$('[data-option-index]');
    const idInput = $('[data-variant-id]');
    const addBtn = $('[data-add-btn]');
    const update = () => {
      const opts = selects.map((s) => s.value);
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    selects.forEach((s) => s.addEventListener('change', update));
  }

  /* ---------- Sticky pre-order bar (mobile product page) ---------- */
  const sticky = $('[data-sticky-buy]');
  const mainBtn = $('[data-add-btn]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $('[data-sticky-submit]', sticky).tabIndex = show ? 0 : -1;
    }).observe(mainBtn);
    $('[data-sticky-submit]', sticky).addEventListener('click', () => {
      const form = document.getElementById('ProductForm');
      form && form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
})();
